import { useTranslator } from 'translation/useTranslator';
import { IconType } from '../../../@types/icons';
import StatusIcon from './StatusIcon';

type EnabledIconProps = {
  tooltip?: string;
  size?: string;
  color?: string;
};
const EnabledIcon = ({ tooltip, size, color = 'success.main' }: EnabledIconProps) => {
  const translator = useTranslator();
  return (
    <StatusIcon
      tooltip={tooltip ?? translator.enabled()}
      size={size}
      color={color}
      icon={IconType.success}
    />
  );
};

export default EnabledIcon;
